var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "profile", staticClass: "account-profile" },
    [
      _c("h2", [_vm._v("Личные данные")]),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.isLoading
            ? _c("ui-loader", { staticClass: "loader", attrs: { size: "60" } })
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "account-profile-wrapper" },
        [
          _c("ui-input", {
            attrs: {
              label: "Фамилия",
              placeholder: "Укажите вашу фамилию",
              validate: "surname",
              clearable: ""
            },
            model: {
              value: _vm.form.lastName,
              callback: function($$v) {
                _vm.$set(_vm.form, "lastName", $$v)
              },
              expression: "form.lastName"
            }
          }),
          _c("ui-input", {
            attrs: {
              label: "Имя*",
              placeholder: "Укажите ваше имя",
              validate: "name",
              clearable: ""
            },
            model: {
              value: _vm.form.firstName,
              callback: function($$v) {
                _vm.$set(_vm.form, "firstName", $$v)
              },
              expression: "form.firstName"
            }
          }),
          _c("ui-input", {
            attrs: {
              label: "Отчество",
              placeholder: "Укажите ваше отчество",
              validate: "surname",
              clearable: ""
            },
            model: {
              value: _vm.form.secondName,
              callback: function($$v) {
                _vm.$set(_vm.form, "secondName", $$v)
              },
              expression: "form.secondName"
            }
          }),
          _c(
            "div",
            [
              _c("ui-select", {
                attrs: {
                  label: "Пол*",
                  options: [
                    { name: "Мужчина", value: "male" },
                    { name: "Женщина", value: "female" }
                  ],
                  placeholder: "Не выбран",
                  "empty-value": "Не выбран"
                },
                model: {
                  value: _vm.form.gender,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "gender", $$v)
                  },
                  expression: "form.gender"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            [
              _c("ui-datepicker", {
                attrs: { label: "Дата рождения*", required: "" },
                model: {
                  value: _vm.form.birthday,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "birthday", $$v)
                  },
                  expression: "form.birthday"
                }
              })
            ],
            1
          ),
          _c("ui-city-suggest", {
            attrs: {
              label: "Город*",
              current: { id: _vm.form.cityId, name: _vm.cityName }
            },
            on: {
              change: function(city) {
                _vm.form.cityId = city.id
                _vm.cityName = city.name
              }
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "account-profile-subtitle" }, [
        _vm._v("\n    Семья\n  ")
      ]),
      _c(
        "div",
        { staticClass: "account-profile-wrapper" },
        [
          _c("ui-checkbox", {
            attrs: { label: "У меня есть супруг(а)" },
            model: {
              value: _vm.spouse,
              callback: function($$v) {
                _vm.spouse = $$v
              },
              expression: "spouse"
            }
          }),
          _c(
            "transition",
            { attrs: { name: "fade" } },
            [
              _vm.spouse
                ? _c("ui-datepicker", {
                    attrs: { label: "Дата рождения супруга(и)*", required: "" },
                    model: {
                      value: _vm.form.spouse.birthday,
                      callback: function($$v) {
                        _vm.$set(_vm.form.spouse, "birthday", $$v)
                      },
                      expression: "form.spouse.birthday"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c("ui-checkbox", {
        staticClass: "check-childrens",
        attrs: { label: "У меня есть дети" },
        model: {
          value: _vm.children,
          callback: function($$v) {
            _vm.children = $$v
          },
          expression: "children"
        }
      }),
      _vm._l(_vm.form.children, function(child, i) {
        return _c(
          "div",
          { key: child.id + "-" + i, staticClass: "account-profile-child" },
          [
            _c(
              "div",
              { staticClass: "account-profile-wrapper" },
              [
                _c(
                  "div",
                  [
                    _c("ui-select", {
                      attrs: {
                        options: [
                          { name: "Мальчик", value: "male" },
                          { name: "Девочка", value: "female" }
                        ],
                        placeholder: "Не выбран",
                        "empty-value": "Не выбран",
                        label: "Пол*"
                      },
                      model: {
                        value: child.gender,
                        callback: function($$v) {
                          _vm.$set(child, "gender", $$v)
                        },
                        expression: "child.gender"
                      }
                    })
                  ],
                  1
                ),
                _c("ui-datepicker", {
                  staticClass: "input birthday",
                  attrs: {
                    validate: "child_date",
                    label: "Дата рождения*",
                    required: ""
                  },
                  model: {
                    value: child.birthday,
                    callback: function($$v) {
                      _vm.$set(child, "birthday", $$v)
                    },
                    expression: "child.birthday"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "remove-icon",
                on: {
                  click: function($event) {
                    return _vm.removeChild(i)
                  }
                }
              },
              [
                _c("f-sprite-icon", {
                  attrs: { "icon-link": _vm.$options.icons.IconClose.id }
                })
              ],
              1
            )
          ]
        )
      }),
      _vm.children && _vm.form.children.length < 10
        ? _c(
            "div",
            { staticClass: "add-button", on: { click: _vm.addChild } },
            [
              _c(
                "div",
                { staticClass: "icon" },
                [
                  _c("f-sprite-icon", {
                    attrs: { "icon-link": _vm.$options.icons.IconPlus.id }
                  })
                ],
                1
              ),
              _vm._v("\n    Добавить ребенка\n  ")
            ]
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "account-profile-contacts" },
        [
          _c("h2", [_vm._v("Контактные данные")]),
          _c("profile-contacts", { staticClass: "account-profile-wrapper" })
        ],
        1
      ),
      _c(
        "div",
        { class: ["button", { scrollable: !_vm.buttonScrollEnded }] },
        [
          _c("ui-button", {
            attrs: {
              wide: "",
              large: "",
              text: "Сохранить",
              disabled: !_vm.valid || _vm.isLoading
            },
            on: { click: _vm.updateProfile }
          })
        ],
        1
      ),
      _c("div", { staticClass: "copyright" }, [
        _vm._v("\n    Нажимая на кнопку «Сохранить» вы принимаете условия "),
        _c(
          "a",
          {
            attrs: {
              target: _vm.adaptive.isDesktop ? "_blank" : "_self",
              href: "/agreement"
            }
          },
          [_vm._v("пользовательского соглашения")]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }